"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionWithTextfieldRequiredSchema = exports.QuestionWithTextfieldSchema = void 0;
exports.default = QuestionWithTextfield;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Box_1 = __importDefault(require("@mui/material/Box"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const FormHelperText_1 = __importDefault(require("@mui/material/FormHelperText"));
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("zod");
exports.QuestionWithTextfieldSchema = zod_1.z.object({
    checkbox: zod_1.z.coerce.boolean(),
    additionalDetails: zod_1.z.coerce.string(),
});
exports.QuestionWithTextfieldRequiredSchema = zod_1.z
    .object({
    checkbox: zod_1.z.coerce.boolean(),
    additionalDetails: zod_1.z.coerce.string(),
})
    .partial()
    .refine((data) => data.checkbox || data.additionalDetails, 'You are required to make an entry.');
function QuestionWithTextfield({ name, questionLabel, checkboxLabel, required = false, dataTestId, }) {
    var _a;
    const { control } = (0, react_hook_form_1.useFormContext)();
    const { field: textFieldInput, formState: { errors }, } = (0, react_hook_form_1.useController)({ name: `${name}.additionalDetails`, control });
    const { field: checkboxInput } = (0, react_hook_form_1.useController)({ name: `${name}.checkbox`, control });
    const [showRequired, setShowRequired] = (0, react_1.useState)(required);
    const fieldId = (0, react_1.useId)();
    const testId = dataTestId ? `${dataTestId}_${fieldId}` : 'question_with_textfield_input';
    const handleTextfieldChange = (e) => {
        textFieldInput.onChange(e.target.value);
        const checkboxChecked = !!(checkboxInput === null || checkboxInput === void 0 ? void 0 : checkboxInput.value) || false;
        const validEntry = !!e.target.value || checkboxChecked;
        setShowRequired(!validEntry);
    };
    const handleCheckboxChange = (e) => {
        checkboxInput.onChange(e.target.checked);
        const textfieldEntry = !!textFieldInput.value;
        const validEntry = e.target.checked || textfieldEntry;
        setShowRequired(!validEntry);
    };
    const error = errors[name];
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, { sx: {
            display: 'flex',
            flexDirection: 'column',
        }, children: [(0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { label: questionLabel, labelPlacement: "top", required: showRequired, sx: {
                    marginLeft: 0,
                    marginRight: 0,
                    alignItems: 'start',
                }, control: (0, jsx_runtime_1.jsx)(TextField_1.default, Object.assign({}, textFieldInput, { sx: {
                        paddingTop: 1,
                        width: '100%',
                    }, error: Boolean(error), multiline: true, rows: 4, inputProps: {
                        'data-test-id': testId,
                        maxLength: 350,
                    }, onChange: handleTextfieldChange })) }), (0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { label: checkboxLabel, control: (0, jsx_runtime_1.jsx)(Checkbox_1.default, Object.assign({}, checkboxInput, { onChange: handleCheckboxChange })) }), (error === null || error === void 0 ? void 0 : error.root) && showRequired && ((0, jsx_runtime_1.jsx)(FormHelperText_1.default, { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (_a = error === null || error === void 0 ? void 0 : error.root) === null || _a === void 0 ? void 0 : _a.message }) }))] }));
}
//# sourceMappingURL=QuestionWithTextfield.js.map